module.exports = __webpack_public_path__ + "img/ico-cedulac.bf4ec2f2.png";